"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const formatters_1 = require("../../utility/formatters");
const createCurrencyFormatter_1 = require("../../services/locale/createCurrencyFormatter");
const time_1 = require("../../utility/time");
const user_helpers_1 = require("../../utility/user_helpers");
const base_1 = __importDefault(require("../../client/buttons/base"));
const ContestSponsorsList_1 = __importDefault(require("../../client/cards/contest_card/helpers/ContestSponsorsList"));
const horizontal_scroll_box_1 = __importDefault(require("../../client/wrappers/horizontal_scroll_box"));
const icon_1 = __importDefault(require("../../client/icon"));
const LazyImage_1 = __importDefault(require("../../client/reusable_components/LazyImage"));
const Popup_1 = __importDefault(require("../../client/reusable_components/Popup"));
const StoryJSON_1 = __importDefault(require("../../client/draftster/story_json_renderers/StoryJSON"));
const FaqTab_1 = __importDefault(require("./FaqTab"));
const PrizesTab_1 = __importDefault(require("./PrizesTab"));
const RegisterTab_1 = __importDefault(require("./RegisterTab"));
const SurveysTab_1 = __importDefault(require("./SurveysTab"));
const types_1 = require("./types");
const buttons_css_1 = __importDefault(require("../../styles/global_ui/buttons.css"));
const layout_css_1 = __importDefault(require("../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../styles/global_ui/util.css"));
const style_css_1 = __importDefault(require("./style.css"));
const c = {
    header: `${layout_css_1.default.wrapper1170} ${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.fullWidth} ${layout_css_1.default.paddingBottom30} ${layout_css_1.default.paddingTop30} ${layout_css_1.default.paddingRight15} ${layout_css_1.default.paddingLeft15} ${layout_css_1.default.flexRowWrap}`,
    earnedPoints: `${layout_css_1.default.flexCenterItems} ${typography_css_1.default.bodyM} ${layout_css_1.default.paddingRight15} ${layout_css_1.default.marginLeftAuto} ${layout_css_1.default.hiddenMedDown}`,
    navWrapper: `${layout_css_1.default.wrapper1170} ${layout_css_1.default.marginAuto} `,
    navBar: `${layout_css_1.default.flex} ${util_css_1.default.ulReset} ${style_css_1.default.navBar}`,
    view: ({ isActive }) => [
        typography_css_1.default.bodyM,
        typography_css_1.default.bold,
        style_css_1.default.navItem,
        isActive ? style_css_1.default.activeTab : '',
    ].join(' '),
    section: `${layout_css_1.default.wrapper1170} ${layout_css_1.default.marginAuto} ${layout_css_1.default.paddingBottom60} ${layout_css_1.default.paddingTop30} ${layout_css_1.default.paddingRight15} ${layout_css_1.default.paddingLeft15}`,
    icon: `${typography_css_1.default.lake} ${layout_css_1.default.marginRight5}`,
    buttonGroup: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter10} ${layout_css_1.default.marginLeftAuto} ${style_css_1.default.buttonGroup}`,
    endDate: `${layout_css_1.default.marginTopAuto} ${typography_css_1.default.bold} ${layout_css_1.default.flexCenterItems} ${layout_css_1.default.flexAlignSelfEnd} ${style_css_1.default.endDate}`,
    verificationNeeded: `${layout_css_1.default.marginRight5} ${typography_css_1.default.bodyS} ${typography_css_1.default.error}`,
    link: `${typography_css_1.default.error} ${typography_css_1.default.underline} ${typography_css_1.default.bold}`,
};
const currencyFormatter = (0, createCurrencyFormatter_1.createUSCurrencyFormatter)();
const Tip = ({ onClick }) => (react_1.default.createElement("div", { className: style_css_1.default.tip },
    "Entries are calculated and updated once per day. See",
    ' ',
    react_1.default.createElement("span", { className: typography_css_1.default.linkBlue, onClick: onClick }, "rules"),
    ' ',
    "to learn more."));
const CurrentView = ({ activeTab, giveaway, isRegistered, prizeIcons, setIsRegistered, handleTabChange, user, }) => {
    switch (activeTab) {
        case 'overview':
            return react_1.default.createElement(StoryJSON_1.default, { className: style_css_1.default.content, story: giveaway.content });
        case 'rules':
            return react_1.default.createElement(StoryJSON_1.default, { className: style_css_1.default.content, story: giveaway.rules });
        case 'prizes':
            return (react_1.default.createElement(PrizesTab_1.default, { isRegistered: isRegistered, prizeIcons: prizeIcons, prizes: giveaway.prizes }));
        case 'surveys':
            return (react_1.default.createElement(SurveysTab_1.default, { isRegistered: isRegistered, surveys: giveaway.surveys }));
        case 'faqs':
            return react_1.default.createElement(FaqTab_1.default, null);
        case 'register':
            return (react_1.default.createElement(RegisterTab_1.default, { giveawayId: giveaway.id, isRegistered: isRegistered, prizes: giveaway.prizes, registrationSurveys: giveaway.registration_surveys, setActiveTab: (view) => handleTabChange({ view }), setIsRegistered: setIsRegistered, title: giveaway.title, url: giveaway.url, user: user }));
        default:
            (0, types_1.throwTypeError)(activeTab);
    }
};
const GiveawayPage = ({ giveaway, query, user, prizeIcons }) => {
    const [activeTab, setActiveTab] = (0, react_1.useState)(query || 'overview');
    const views = ['overview', 'rules', 'prizes', 'surveys', 'faqs'];
    const { cover_image, earned_entries, end_date_in_pdt, is_registered_to_giveaway, sponsors, title, total_prize_value, } = giveaway;
    const [isRegistered, setIsRegistered] = (0, react_1.useState)(is_registered_to_giveaway);
    const verificationStarted = (0, user_helpers_1.isPendingOrVerified)(user.tier);
    const endDate = (0, time_1.timestampToRelativeTimeRemaining)({ timestamp: end_date_in_pdt, minCutoff: 'day' });
    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            const view = e.target.getAttribute('value');
            handleTabChange({ view });
        }
    };
    const handleTabChange = ({ view }) => {
        if (!window)
            return;
        setActiveTab(view);
        const location = window.location;
        // strip away the url query params when switching tabs, this way if a header link was clicked, it doesn't transfer over to the new view.
        const url = new URL(location.origin + location.pathname);
        url.searchParams.set('view', view);
        window.history.pushState({}, '', url);
        // Scroll to beginning of tab section
        setTimeout(() => {
            const section = document.querySelector('section');
            section?.scrollIntoView({ behavior: 'smooth' });
        }, 0);
    };
    const handleRegister = () => {
        if (!isRegistered) {
            handleTabChange({ view: 'register' });
        }
        else {
            handleTabChange({ view: 'faqs' });
        }
    };
    return (react_1.default.createElement("main", null,
        react_1.default.createElement(LazyImage_1.default, { alt: `${title}, a Hackster Giveaway`, className: layout_css_1.default.fullWidth, ratio: "4:1", setStyle: false, src: cover_image?.url, width: 2560 }),
        react_1.default.createElement("div", { className: layout_css_1.default.flexColumn },
            react_1.default.createElement("div", { className: c.header },
                react_1.default.createElement("div", { className: `${layout_css_1.default.flexColumn} ${layout_css_1.default.marginRight30} ${style_css_1.default.header}` },
                    react_1.default.createElement("h1", { className: typography_css_1.default.h1 }, title),
                    react_1.default.createElement(ContestSponsorsList_1.default, { classList: {
                            root: `${layout_css_1.default.marginTop0} ${layout_css_1.default.marginBottom10}`,
                            typography: `${typography_css_1.default.bodyM}`,
                        }, sponsors: sponsors, sponsorsConfig: { limit: 12 } }),
                    react_1.default.createElement("p", { className: `${layout_css_1.default.margin0}` },
                        "Total pool prize of",
                        ' ',
                        react_1.default.createElement("span", { className: typography_css_1.default.bold },
                            currencyFormatter.format(total_prize_value),
                            "+")),
                    isRegistered && earned_entries > 0 && (react_1.default.createElement("div", { className: `${layout_css_1.default.hiddenMedUp}` },
                        react_1.default.createElement("p", { className: `${layout_css_1.default.flexCenterItems} ${layout_css_1.default.margin0}` },
                            react_1.default.createElement("span", null,
                                earned_entries,
                                ' ',
                                earned_entries > 1 ? 'entries' : 'entry',
                                ' ',
                                "earned"),
                            react_1.default.createElement(Popup_1.default, { align: "center", classList: { trigger: `${buttons_css_1.default.unset} ${buttons_css_1.default.xs} ${style_css_1.default.triggerIcon}` }, hasArrow: true, side: "bottom", trigger: react_1.default.createElement(icon_1.default, { name: "info-circle", size: 16 }) },
                                react_1.default.createElement(Tip, { onClick: () => setActiveTab('rules') }))),
                        !verificationStarted
                            && (react_1.default.createElement("p", { className: c.verificationNeeded },
                                "You still need to",
                                ' ',
                                react_1.default.createElement("a", { className: c.link, href: "/verify", rel: "noopener noreferrer", target: "_blank" }, "get verified"),
                                ' ',
                                "before your entries can be counted."))))),
                react_1.default.createElement("div", { className: c.buttonGroup },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(base_1.default, { colorStyle: isRegistered ? 'secondary' : '', onClick: handleRegister, size: "lg" }, isRegistered ? 'Earn more entries' : 'Enter for free')),
                    react_1.default.createElement("div", { className: c.endDate },
                        react_1.default.createElement(icon_1.default, { className: c.icon, name: "rewind", size: 20 }),
                        endDate === '0 days left' ? 'Ends today' : endDate))),
            react_1.default.createElement("div", { className: `${util_css_1.default.borderBottom} ${util_css_1.default.borderTop}` },
                react_1.default.createElement("div", { className: c.navWrapper },
                    react_1.default.createElement(horizontal_scroll_box_1.default, null,
                        react_1.default.createElement("nav", null,
                            react_1.default.createElement("ul", { className: c.navBar, role: "tablist" }, views.map((view) => (react_1.default.createElement("li", { key: view, className: c.view({ isActive: activeTab === view }), onClick: () => handleTabChange({ view }), onKeyDown: handleKeyPress, role: "tab", tabIndex: 0, value: view }, view === 'faqs' ? 'FAQs' : (0, formatters_1.capitalize)(view)))))),
                        isRegistered && earned_entries > 0 && (react_1.default.createElement("p", { className: `${c.earnedPoints}` },
                            !verificationStarted && (react_1.default.createElement("span", { className: c.verificationNeeded },
                                "You still need to",
                                ' ',
                                react_1.default.createElement("a", { className: c.link, href: "/verify", rel: "noopener noreferrer", target: "_blank" }, "get verified"),
                                ' ',
                                "before your entries can be counted.")),
                            earned_entries,
                            ' ',
                            earned_entries > 1 ? 'entries' : 'entry',
                            ' ',
                            "earned",
                            react_1.default.createElement(Popup_1.default, { align: "center", classList: { trigger: `${buttons_css_1.default.unset} ${buttons_css_1.default.xs} ${style_css_1.default.triggerIcon}` }, hasArrow: true, side: "bottom", trigger: react_1.default.createElement(icon_1.default, { name: "info-circle", size: 16 }) },
                                react_1.default.createElement(Tip, { onClick: () => setActiveTab('rules') }))))))),
            react_1.default.createElement("section", { className: c.section, role: "tabpanel" },
                react_1.default.createElement(CurrentView, { activeTab: activeTab, giveaway: giveaway, handleTabChange: handleTabChange, isRegistered: isRegistered, prizeIcons: prizeIcons, setIsRegistered: setIsRegistered, user: user })))));
};
exports.default = GiveawayPage;
